import React, {
  useEffect,
  useState,
} from "react";

import Api from "../../../../shared/api/api";
import "../styles/AdminTestimonials.css";

export default function AdminTestimonials() {
  const defaultTestimonial = {
    name: "",
    content: "",
    source: "",
    featured: false,
  };

  const [testimonials, setTestimonials] =
    useState([]);

  const [testimonial, setTestimonial] =
    useState(defaultTestimonial);

  const [showModal, setShowModal] =
    useState(false);

  const [isEditMode, setIsEditMode] =
    useState(false);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const data = await Api.getAllAuthor(
        "api/testimonials"
      );

      const testimonialRecords =
        Array.isArray(data)
          ? data
          : data?.testimonials || [];

      setTestimonials(testimonialRecords);
    } catch (err) {
      console.error(
        "Error fetching testimonials:",
        err
      );

      setTestimonials([]);
    }
  };

  const handleChange = (event) => {
    const {
      name,
      value,
      type,
      checked,
    } = event.target;

    setTestimonial((previous) => ({
      ...previous,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));
  };

  const openModal = () => {
    setTestimonial(defaultTestimonial);
    setIsEditMode(false);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setTestimonial(defaultTestimonial);
    setIsEditMode(false);
  };

  const handleEdit = (
    selectedTestimonial
  ) => {
    setTestimonial({
      ...defaultTestimonial,
      ...selectedTestimonial,
    });

    setIsEditMode(true);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Delete this testimonial?"
    );

    if (!confirmed) {
      return;
    }

    try {
      await Api.deleteAuthor(
        "api/testimonials",
        id
      );

      await fetchTestimonials();
    } catch (err) {
      console.error(
        "Error deleting testimonial:",
        err
      );

      window.alert(
        "The testimonial could not be deleted."
      );
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      if (isEditMode) {
        await Api.updateAuthor(
          "api/testimonials",
          testimonial.id,
          testimonial
        );
      } else {
        await Api.createAuthor(
          "api/testimonials",
          testimonial
        );
      }

      await fetchTestimonials();
      closeModal();
    } catch (err) {
      console.error(
        "Error saving testimonial:",
        err
      );

      window.alert(
        "The testimonial could not be saved."
      );
    }
  };

  const toggleFeatured = async (
    id,
    current
  ) => {
    try {
      await Api.updateAuthor(
        "api/testimonials",
        id,
        {
          featured: !current,
        }
      );

      await fetchTestimonials();
    } catch (err) {
      console.error(
        "Error toggling featured:",
        err
      );

      window.alert(
        "The featured status could not be updated."
      );
    }
  };

  return (
    <div className="adminPageContainer">
      <h1 className="testimonialTitle">
        Admin Testimonial Page
      </h1>

      <button
        type="button"
        className="addTestimonialBtn"
        onClick={openModal}
      >
        Add Testimonial
      </button>

      {showModal && (
        <div className="modalOverlay">
          <div className="modalContent">
            <form
              className="testimonialForm"
              onSubmit={handleSubmit}
            >
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={testimonial.name}
                onChange={handleChange}
                required
              />

              <textarea
                name="content"
                placeholder="Testimonial"
                value={testimonial.content}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="source"
                placeholder="Source (optional)"
                value={testimonial.source}
                onChange={handleChange}
              />

              <label className="checkboxRow">
                <input
                  type="checkbox"
                  name="featured"
                  checked={
                    Boolean(
                      testimonial.featured
                    )
                  }
                  onChange={handleChange}
                />

                Featured
              </label>

              <div className="buttonRow">
                <button
                  className="publishingSubmitBtn"
                  type="submit"
                >
                  {isEditMode
                    ? "Update Testimonial"
                    : "Submit Testimonial"}
                </button>

                <button
                  className="cancelBtn"
                  type="button"
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="adminTestimonialsList">
        {testimonials.length === 0 && (
          <p
            style={{
              textAlign: "center",
              color: "#888",
            }}
          >
            No testimonials available.
          </p>
        )}

        {testimonials.map(
          (currentTestimonial) => (
            <div
              className="adminTestimonialRow"
              key={currentTestimonial.id}
            >
              <div className="testimonialText">
                <p>
                  "
                  {
                    currentTestimonial.content
                  }
                  "
                </p>

                <strong>
                  - {currentTestimonial.name}
                </strong>

                {currentTestimonial.source && (
                  <span className="sourceTag">
                    (
                    {
                      currentTestimonial.source
                    }
                    )
                  </span>
                )}
              </div>

              <div className="testimonialActions">
                <button
                  type="button"
                  className="testimonialEditBtn"
                  onClick={() =>
                    handleEdit(
                      currentTestimonial
                    )
                  }
                >
                  Edit
                </button>

                <button
                  type="button"
                  className="testimonialDeleteBtn"
                  onClick={() =>
                    handleDelete(
                      currentTestimonial.id
                    )
                  }
                >
                  Delete
                </button>

                <button
                  type="button"
                  className="featureToggleBtn"
                  aria-label={
                    currentTestimonial.featured
                      ? "Remove from featured testimonials"
                      : "Mark as featured"
                  }
                  onClick={() =>
                    toggleFeatured(
                      currentTestimonial.id,
                      currentTestimonial.featured
                    )
                  }
                >
                  <img
                    src={
                      currentTestimonial.featured
                        ? "https://icons.getbootstrap.com/assets/icons/star-fill.svg"
                        : "https://icons.getbootstrap.com/assets/icons/star.svg"
                    }
                    alt=""
                    aria-hidden="true"
                    className={`featureIcon ${
                      currentTestimonial.featured
                        ? "filled"
                        : ""
                    }`}
                  />
                </button>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}